// extracted by mini-css-extract-plugin
module.exports = {"main-title":"main-title--QUTzi","-small":"-small--1M9Z3"};